<template>
    <div class="web-index">
        <div class="page-one">
            <div class="page-one-logo">
                <img src="../../assets/index/logo.png" />
            </div>
            <div class="page-one-title">四川省知识产权发展研究中心专利申请预评估系统</div>
            <div class="page-one-btn">
                <div class="btn" @click="jumpEval()">前往评估</div>
            </div>
        </div>
        <div class="page-two">
            <div class="page-two-title">语义智能评估 + 专家深度复核 —— 从可专利性到市场前景，一站式预判</div>
            <div class="page-two-desc">基于全库中文专利语料与机器深度学习技术，融合语义智能评估与专家复核，为您提供科学、客观、高效的可专利性评价、技术竞争情况及市场前景预测</div>
            <div class="page-two-icon">
                <div class="icon-item">
                    <div class="icon-item-img"><img src="../../assets/index/page-two-1.png"/></div>
                    <div class="icon-item-text">语义智能评估</div>
                </div>
                <div class="icon-item">
                    <div class="icon-item-img"><img src="../../assets/index/page-two-2.png"/></div>
                    <div class="icon-item-text">专家深度评估</div>
                </div>
                <div class="icon-item">
                    <div class="icon-item-img"><img src="../../assets/index/page-two-3.png"/></div>
                    <div class="icon-item-text">50篇对比文献</div>
                </div>
                <div class="icon-item">
                    <div class="icon-item-img"><img src="../../assets/index/page-two-4.png"/></div>
                    <div class="icon-item-text">全库中文专利语料</div>
                </div>
            </div>
            <div class="page-two-bottom">三大维度--全方位精准测评</div>
        </div>
        <div class="page-three">
            <div class="page-three-item">
                <div class="three-item-img"><img src="../../assets/index/page-three-4.png"/></div>
                <div class="three-item-text1">可专利性评价</div>
                <div class="three-item-text2">评估新颖性、创造性、实用性，预判授权概率</div>
            </div>
            <div class="page-three-item">
                <div class="three-item-img"><img src="../../assets/index/page-three-5.png"/></div>
                <div class="three-item-text1">技术竞争情况</div>
                <div class="three-item-text2">识别竞争对手与专利壁垒，洞察技术布局</div>
            </div>
            <div class="page-three-item">
                <div class="three-item-img"><img src="../../assets/index/page-three-6.png"/></div>
                <div class="three-item-text1">市场前景预测</div>
                <div class="three-item-text2">预判转化潜力与商业价值，支撑成果落地</div>
            </div>
        </div>
        <div class="page-four" style="padding-bottom: 60px;">
            <div class="page-four-title">四大技术突破</div>
            <div style="display: flex;justify-content: center;margin-top: 40px;">
                <div style="display: flex;">
                    <div style="width: 80px;height: 80px;background-color: #F2F2F2;">
                        <img style="margin-top: 20px;" src="../../assets/index/page-four-1.png" />
                    </div>
                    <div style="width: 230px;margin-left: 30px;">
                        <div style="font-size: 20px;font-weight: 700;text-align: left;">深度语义挖掘</div>
                        <div style="text-align: left;font-size: 16px;color: #666666;margin-top: 10px;">穿透著录项，直达权利要求书与说明书核心文本</div>
                    </div>
                </div>
                <div style="display: flex;margin-left: 100px;">
                    <div style="width: 80px;height: 80px;background-color: #F2F2F2;">
                        <img style="margin-top: 20px;" src="../../assets/index/page-four-2.png" />
                    </div>
                    <div style="width: 230px;margin-left: 30px;">
                        <div style="font-size: 20px;font-weight: 700;text-align: left;">全源数据支撑</div>
                        <div style="text-align: left;font-size: 16px;color: #666666;margin-top: 10px;">整合法律、诉讼、缴费、海关、奖项等全方位数据</div>
                    </div>
                </div>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 40px;">
                <div style="display: flex;">
                    <div style="width: 80px;height: 80px;background-color: #F2F2F2;">
                        <img style="margin-top: 20px;" src="../../assets/index/page-four-3.png" />
                    </div>
                    <div style="width: 230px;margin-left: 30px;">
                        <div style="font-size: 20px;font-weight: 700;text-align: left;">智能数学模型</div>
                        <div style="text-align: left;font-size: 16px;color: #666666;margin-top: 10px;">行业领先的加权算法，固化专家评估经验</div>
                    </div>
                </div>
                <div style="display: flex;margin-left: 100px;">
                    <div style="width: 80px;height: 80px;background-color: #F2F2F2;">
                        <img style="margin-top: 20px;" src="../../assets/index/page-four-4.png" />
                    </div>
                    <div style="width: 230px;margin-left: 30px;">
                        <div style="font-size: 20px;font-weight: 700;text-align: left;">降本增效</div>
                        <div style="text-align: left;font-size: 16px;color: #666666;margin-top: 10px;">大幅降低传统专家评估的人力与时间成本</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-five">
            <div class="page-four-title">操作流程</div>
            <div style="display: flex;justify-content: center;margin-top: 30px;">
                <div style="width: 240px;text-align: center;">
                    <div class="process-number">1</div>
                    <div style="margin-top: 20px;"><img src="../../assets/index/page-five-1.png"></div>
                    <div style="font-size: 20px;font-weight: 700;margin-top: 20px;">输入信息</div>
                    <div style="font-size: 16px;color: #666666;margin-top: 20px;">在评估界面输入专利相关信息</div>
                </div>
                <div style="width: 240px;text-align: center;margin-left: 30px;">
                    <div class="process-number">2</div>
                    <div style="margin-top: 20px;"><img src="../../assets/index/page-five-2.png"></div>
                    <div style="font-size: 20px;font-weight: 700;margin-top: 20px;">系统运算</div>
                    <div style="font-size: 16px;color: #666666;margin-top: 20px;">模型自动调取大数据并根据32个指标进行加权计算</div>
                </div>
                <div style="width: 240px;text-align: center;margin-left: 30px;">
                    <div class="process-number">3</div>
                    <div style="margin-top: 20px;"><img src="../../assets/index/page-five-3.png"></div>
                    <div style="font-size: 20px;font-weight: 700;margin-top: 20px;">获取报告</div>
                    <div style="font-size: 16px;color: #666666;margin-top: 20px;">在评估结果界面下载最近的评估报告</div>
                </div>
            </div>
        </div>
        <div class="page-bottom">版权所有：Copyright © 四川省知识产权发展研究中心</div>
        <!-- 登录弹窗 -->
        <div>
            <el-dialog :close-on-click-modal="false" :visible.sync="loginVisible" width="520px" title="登录系统" class="login-dialog">
                <!-- 角色切换 -->
                <el-tabs v-model="activeRole" @tab-click="handleRoleChange" class="role-tabs">
                    <el-tab-pane label="用户登录" name="user"></el-tab-pane>
                    <el-tab-pane label="专家登录" name="agent"></el-tab-pane>
                    <el-tab-pane label="管理员登录" name="admin"></el-tab-pane>
                </el-tabs>
                <!-- 登录表单区域（非注册状态） -->
                <div v-if="!showRegister">
                    <!-- 登录方式切换 -->
                    <el-radio-group v-model="loginMethod" size="small" class="login-method-switch">
                        <el-radio-button label="password">密码登录</el-radio-button>
                        <el-radio-button label="sms">验证码登录</el-radio-button>
                    </el-radio-group>

                    <!-- 密码登录表单 -->
                    <el-form v-if="loginMethod === 'password'" :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="80px" class="login-form">
                        <el-form-item label="账号" prop="username">
                            <el-input v-model="loginForm.username" placeholder="请输入账号/手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" show-password></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleLogin" style="width:100%">登录</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 验证码登录表单 -->
                    <el-form v-else :model="smsForm" :rules="smsRules" ref="smsFormRef" label-width="80px" class="login-form">
                        <el-form-item label="手机号" prop="mobile">
                            <el-input v-model="smsForm.mobile" placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="smsCode">
                            <div style="display: flex; gap: 10px;">
                                <el-input v-model="smsForm.smsCode" placeholder="请输入验证码"></el-input>
                                <el-button :disabled="smsCooldown > 0" @click="sendSmsCode">{{ smsCooldown > 0 ? `${smsCooldown}秒后重试` : '获取验证码' }}</el-button>
                            </div>
                        </el-form-item>
                        <!-- 用户登录且验证码登录时显示滑块验证 -->
                        <el-form-item v-if="activeRole === 'user'" label="滑块验证" required>
                            <div class="slider-container">
                                <div class="slider-track" :class="{ 'slider-success': sliderVerified }">
                                    <div class="slider-thumb" @mousedown="startDrag" :style="{ left: thumbPosition + 'px' }"></div>
                                    <div class="slider-text" v-if="!sliderVerified">请按住滑块，拖动到最右侧</div>
                                    <div class="slider-text success-text" v-else>验证通过</div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleLogin" style="width:100%">登录</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 注册按钮（仅用户登录时显示） -->
                    <div class="register-tip" v-if="activeRole === 'user'">
                        <span>还没有账号？</span>
                        <el-button type="text" @click="showRegister = true">立即注册</el-button>
                    </div>
                </div>

                <!-- 注册表单 -->
                <div v-else>
                    <div class="register-title">用户注册</div>
                    <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" label-width="80px" class="login-form">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="registerForm.name" placeholder="请输入真实姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="mobile">
                            <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input type="password" v-model="registerForm.password" placeholder="6-20位数字或字母" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="confirmPwd">
                            <el-input type="password" v-model="registerForm.confirmPwd" placeholder="请再次输入密码" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="registerCode">
                            <div style="display: flex; gap: 10px;">
                                <el-input v-model="registerForm.registerCode" placeholder="请输入验证码"></el-input>
                                <el-button :disabled="registerCooldown > 0" @click="sendRegisterCode">{{ registerCooldown > 0 ? `${registerCooldown}秒后重试` : '获取验证码' }}</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleRegister" style="width:100%">注册</el-button>
                            <el-button @click="showRegister = false" style="width:100%; margin-top:10px;margin-left: 0px;">返回登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-dialog>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import md5 from 'js-md5'
import { 
    adminLogin,
    getVerifyCode,
    userLogin,
    userRegister,
    agentLogin
 } from '../../api/evalMG'
    export default {
        name: 'index',
        data() {
            // 自定义确认密码校验
            const validateConfirmPwd = (rule, value, callback) => {
                if (value !== this.registerForm.password) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            };
          return {
                loginVisible: false,
                // 角色切换: user / admin
                activeRole: 'user',
                 // 登录方式: password / sms
                 loginMethod: 'password',
                  // 是否显示注册表单
                showRegister: false,
                // 用户/管理员 密码登录表单
                loginForm: {
                    username: '',
                    password: ''
                },
                loginRules: {
                    username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
                },
                // 验证码登录表单
                smsForm: {
                    mobile: '',
                    smsCode: ''
                },
                smsRules: {
                    mobile: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                    ],
                    smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                },
                 // 注册表单
                 registerForm: {
                    name: '',
                    mobile: '',
                    password: '',
                    confirmPwd: '',
                    registerCode: ''
                },
                registerRules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    mobile: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度6-20位', trigger: 'blur' }
                    ],
                    confirmPwd: [
                        { required: true, message: '请再次输入密码', trigger: 'blur' },
                        { validator: validateConfirmPwd, trigger: 'blur' }
                    ],
                    registerCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                },
                // 滑块验证相关
                sliderVerified: false,
                thumbPosition: 0,
                dragStartX: 0,
                dragStartLeft: 0,
                isDragging: false,
                trackWidth: 0,
                // 验证码倒计时
                smsCooldown: 0,
                registerCooldown: 0,
                cooldownTimer: null,
                // 模拟存储用户列表 (实际应调用后端，此处用localStorage模拟)
                userList: []
            }
        },
        // 注册组件
        components: {

        },
        // 创建完毕状态(里面是操作)
        created() {
            // 初始化用户列表
            const storedUsers = localStorage.getItem('registeredUsers');
            if (storedUsers) {
                this.userList = JSON.parse(storedUsers);
            } else {
                // 预置测试用户（可选）
                this.userList = [];
                localStorage.setItem('registeredUsers', JSON.stringify(this.userList));
            }
        },
        beforeDestroy() {
            if (this.cooldownTimer) clearInterval(this.cooldownTimer);
        },
        // 里面的函数只有调用才会执行
        methods: {
            jumpEval(){
                this.loginVisible = true
                this.resetDialogState();
            },
            // 关闭弹窗时重置状态
            handleCloseDialog(done) {
                this.resetDialogState();
                done();
            },
            resetDialogState() {
                this.activeRole = 'user';
                this.loginMethod = 'password';
                this.showRegister = false;
                this.loginForm = { username: '', password: '' };
                this.smsForm = { mobile: '', smsCode: '' };
                this.registerForm = { name: '', mobile: '', password: '', confirmPwd: '', registerCode: '' };
                this.sliderVerified = false;
                this.thumbPosition = 0;
                if (this.$refs.loginFormRef) this.$refs.loginFormRef.clearValidate();
                if (this.$refs.smsFormRef) this.$refs.smsFormRef.clearValidate();
                if (this.$refs.registerFormRef) this.$refs.registerFormRef.clearValidate();
                // if (this.cooldownTimer) clearInterval(this.cooldownTimer);
                if (this.cooldownTimer) {
                    clearInterval(this.cooldownTimer);
                    this.cooldownTimer = null;
                };
                this.smsCooldown = 0;
                this.registerCooldown = 0;
            },
             // 切换角色时重置表单和滑块
             handleRoleChange() {
                this.showRegister = false;
                this.loginMethod = 'password';
                this.sliderVerified = false;
                this.thumbPosition = 0;
                if (this.$refs.loginFormRef) this.$refs.loginFormRef.clearValidate();
                if (this.$refs.smsFormRef) this.$refs.smsFormRef.clearValidate();
            },
            // 登录主逻辑
            handleLogin() {
                if (this.loginMethod === 'password') {
                    this.$refs.loginFormRef.validate(valid => {
                        if (!valid) return;
                        this.doPasswordLogin();
                    });
                } else {
                    this.$refs.smsFormRef.validate(valid => {
                        if (!valid) return;
                        // 用户登录需要滑块验证通过
                        if (this.activeRole === 'user' && !this.sliderVerified) {
                            this.$message.error('请先完成滑块验证');
                            return;
                        }
                        this.doSmsLogin();
                    });
                }
            },
            // 密码登录
            doPasswordLogin() {
                const { username, password } = this.loginForm;
                let param = {
                        mobile: username,
                        type: 1,
                        password: md5(password)
                    }
                // 根据角色选择对应的登录API
                let api;
                if (this.activeRole === 'user') {
                    api = userLogin;
                } else if (this.activeRole === 'agent') {
                    api = agentLogin;   // 新增agent专用登录接口
                } else {
                    api = adminLogin;   // 管理员或其他角色
                }
                api(param).then(res => {
                    if (res.code === 200) {
                        this.$message.success('登录成功,即将跳转~');
                        localStorage.setItem('userToken', res.data.token);
                        localStorage.setItem('sign', this.activeRole);
                        this.loginVisible = false;
                        if(this.activeRole === 'user'){
                            setTimeout(()=>{
                                this.$router.push({ path: '/customer/applyEval'});
                            },1000)
                        }else if(this.activeRole === 'agent'){
                            setTimeout(()=>{
                                this.$router.push({ path: '/agent/waitEval'});
                            },1000)
                        }else{
                            setTimeout(()=>{
                                this.$router.push({ path: '/system/account'});
                            },1000)
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 验证码登录
            doSmsLogin() {
                const { mobile, smsCode } = this.smsForm;
                // 验证是否为验证码,验证数字
                let pat = /^[0-9]{6}$/
                if(!pat.test(smsCode)){
                    this.$message.error('请输入正确验证码!');
                    return false
                }
                let param = {
                        mobile: mobile,
                        code: smsCode,
                        type: 2
                    }
                // 根据角色选择对应的登录API
                let api;
                if (this.activeRole === 'user') {
                    api = userLogin;
                } else if (this.activeRole === 'agent') {
                    api = agentLogin;   // 新增agent专用登录接口
                } else {
                    api = adminLogin;   // 管理员或其他角色
                }
                api(param).then(res => {
                    if (res.code === 200) {
                        this.$message.success('登录成功,即将跳转~');
                        localStorage.setItem('userToken', res.data.token);
                        localStorage.setItem('sign', this.activeRole);
                        this.loginVisible = false;
                        if(this.activeRole === 'user'){
                            setTimeout(()=>{
                                this.$router.push({ path: '/customer/applyEval'});
                            },1000)
                        }else if(this.activeRole === 'agent'){
                            setTimeout(()=>{
                                this.$router.push({ path: '/agent/waitEval'});
                            },1000)
                        }else{
                            setTimeout(()=>{
                                this.$router.push({ path: '/system/account'});
                            },1000)
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 发送短信验证码（用户/管理员验证码登录）
            sendSmsCode() {
                const mobile = this.smsForm.mobile;
                if (!mobile) {
                    this.$message.error('请输入手机号');
                    return;
                }
                if (!/^1[3-9]\d{9}$/.test(mobile)) {
                    this.$message.error('手机号格式不正确');
                    return;
                }
                // 用户登录且验证码登录时需要滑块验证
                if (this.activeRole === 'user' && !this.sliderVerified) {
                    this.$message.error('请先完成滑块验证');
                    return;
                }
                let param = {
                    mobile: mobile,
                    sign: this.activeRole,
                    scene: 'login'
                }
                getVerifyCode(param)
                .then(res=>{
                    if(res.code == 200){
                        this.$message.success('验证码已发送，有效期15分钟，请勿泄露~');
                        this.startCooldown('sms'); // 启动倒计时
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            // 注册发送验证码
            sendRegisterCode() {
                const mobile = this.registerForm.mobile;
                if (!mobile) {
                    this.$message.error('请输入手机号');
                    return;
                }
                if (!/^1[3-9]\d{9}$/.test(mobile)) {
                    this.$message.error('手机号格式不正确');
                    return;
                }
                let param = {
                    mobile: mobile,
                    scene: 'register',
                    sign: 'user'
                }
                getVerifyCode(param)
                .then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.startCooldown('register'); // 启动倒计时
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
             // 注册逻辑
             handleRegister() {
                this.$refs.registerFormRef.validate(valid => {
                    if (!valid) return;
                    const { name, mobile, password, registerCode } = this.registerForm;
                    let pat = /^[0-9]{6}$/
                    if(!pat.test(registerCode)){
                        this.$message.error('请输入6位数字验证码!');
                        return false
                    }
                    let param = {
                        name: name,
                        mobile: mobile,
                        password: md5(password),
                        code: registerCode
                    }
                    userRegister(param)
                    .then(res=>{
                        if(res.code == 200){
                            this.$message.success('注册成功，请登录');
                            this.showRegister = false;
                            this.smsForm.mobile = mobile;
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                });
            },
            // 倒计时
            startCooldown(type) {
                if (type === 'sms') {
                    this.smsCooldown = 60;
                } else {
                    this.registerCooldown = 60;
                }
                if (this.cooldownTimer) clearInterval(this.cooldownTimer);
                this.cooldownTimer = setInterval(() => {
                    if (type === 'sms') {
                        if (this.smsCooldown <= 1) {
                            clearInterval(this.cooldownTimer);
                            this.smsCooldown = 0;
                        } else {
                            this.smsCooldown--;
                        }
                    } else {
                        if (this.registerCooldown <= 1) {
                            clearInterval(this.cooldownTimer);
                            this.registerCooldown = 0;
                        } else {
                            this.registerCooldown--;
                        }
                    }
                }, 1000);
            },
            // ---------- 滑块验证实现 ----------
            startDrag(e) {
                if (this.sliderVerified) return;
                this.isDragging = true;
                this.dragStartX = e.clientX;
                const thumb = e.target;
                const track = thumb.parentElement;
                this.trackWidth = track.clientWidth - thumb.clientWidth;
                this.dragStartLeft = this.thumbPosition;
                document.addEventListener('mousemove', this.onDrag);
                document.addEventListener('mouseup', this.stopDrag);
                document.addEventListener('mouseleave', this.stopDrag);
                e.preventDefault();
            },
            onDrag(e) {
                if (!this.isDragging) return;
                const deltaX = e.clientX - this.dragStartX;
                let newLeft = this.dragStartLeft + deltaX;
                if (newLeft < 0) newLeft = 0;
                if (newLeft > this.trackWidth) newLeft = this.trackWidth;
                this.thumbPosition = newLeft;
                if (newLeft === this.trackWidth && !this.sliderVerified) {
                    this.sliderVerified = true;
                    this.$message.success('验证成功');
                    this.stopDrag();
                }
            },
            stopDrag() {
                if (!this.isDragging) return;
                this.isDragging = false;
                document.removeEventListener('mousemove', this.onDrag);
                document.removeEventListener('mouseup', this.stopDrag);
                document.removeEventListener('mouseleave', this.stopDrag);
                // 如果未完全验证成功，复位滑块
                if (!this.sliderVerified) {
                    this.thumbPosition = 0;
                }
            }
        }
    }
</script>
<style scoped>
.web-index {
    min-width: 800px !important;
}
.page-one {
    width: 100%;
    height: 420px;
    background-image: url('../../assets/index/page-bg-1.png');
    background-size: cover;
}
.page-one-logo {
    padding-top: 110px;
    text-align: center;
}
.page-one-logo img {
    width: 349px;
    height: 61px;
}
.page-one-title {
    text-align: center;
    font-weight: 700;
    font-size: 36px;
    color: #fff;
    margin-top: 20px;
}
.page-one-btn {
    margin-top: 20px;
}
.page-one-btn .btn{
    background-color: #1D57E7;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    width: 148px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
}
.page-two {
    width: 100%;
    height: 420px;
    background-color: #fff;
}
.page-two-title {
    font-size: 24px;
    font-weight: 700;
    padding-top: 60px;
    text-align: center;
}
.page-two-desc {
    font-size: 16px;
    color: #666666;
    text-align: center;
    margin-top: 12px;
}
.page-three {
    width: 100%;
    height: 300px;
    background-color: #EDEDED;
    display: flex;
    justify-content: center;
    text-align: center;
}
.page-two-icon {
    height: 130px;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    text-align: center;
}
.icon-item {
    width: 160px;
    height: 120px;
    margin-top: 30px;
}
.icon-item-img {
    width: 40px;
    height: 40px;
    margin-left: 60px;
}
.icon-item-text {
    font-size: 16px;
    padding-top: 10px;
}
.page-two-bottom {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin-top: 30px;
}
.page-three-item {
    width: 300px;
    margin: 60px;
}
.three-item-img {
    width: 80px;
    height: 80px;
    margin-left: auto;
    margin-right: auto;
}
.three-item-img img{
    width: 100%;
    height: 100%;
 }
.three-item-text1 {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 700;
}
.three-item-text2 {
    margin-top: 20px;
    font-size: 16px;
    color: #666666;
}
.page-four {
    width: 100%;
    height: 300px;
    background-color: #ffffff;
    justify-content: center;
    text-align: center;
}
.page-four-title {
    font-size: 24px;
    font-weight: 700;
    padding-top: 30px;
    text-align: center;
}
.page-five {
    height: 400px;
    width: 100%;
    background-color: #EDEDED;
}
.process-number {
    width: 28px;
    height: 28px;
    background-color: #D9D9D9;
    border-radius: 50%;
    line-height: 28px;
    font-size: 12px;
    color: #666666;
    margin-left: auto;
    margin-right: auto;
}
.page-bottom {
    background-color: #333;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-size: 14px;
}
/* 登录弹窗样式 */
.login-dialog >>> .el-dialog__body {
    padding: 20px 30px 30px;
}
.role-tabs {
    margin-bottom: 20px;
}
.login-method-switch {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}
.login-form {
    margin-top: 10px;
}
.register-tip {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
}
.register-title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
}
.slider-container {
    width: 100%;
    margin-top: 5px;
}
.slider-track {
    position: relative;
    height: 36px;
    background-color: #e9e9e9;
    border-radius: 18px;
    cursor: pointer;
    user-select: none;
    border: 1px solid #dcdfe6;
}
.slider-thumb {
    position: absolute;
    width: 36px;
    height: 36px;
    background-color: #fff;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    left: 0;
    top: 0;
    border: 1px solid #1D57E7;
    box-sizing: border-box;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="%231D57E7" d="M8 5v14l11-7z"/></svg>');
    background-repeat: no-repeat;
    background-position: center;
}
.slider-text {
    position: absolute;
    width: 100%;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    color: #909399;
    pointer-events: none;
}
.success-text {
    color: #67c23a;
}
.slider-success {
    background-color: #f0f9eb;
    border-color: #67c23a;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue